import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.timerContainer = document.getElementById('timer-container')
  }

  expand() {
    // Hide timer when search is focused
    if (this.timerContainer) {
      this.timerContainer.style.display = 'none'
    }
  }

  collapse() {
    // Show timer when search loses focus (with small delay to allow clicking results)
    setTimeout(() => {
      if (this.timerContainer) {
        this.timerContainer.style.display = ''
      }
    }, 200)
  }
}
